import { useMemo } from 'react'
import useStateControls from '../../../../../hooks/useStateControls'
import { useModal } from '../../../../../hooks/useModal'
import { useSetBackground } from '../../../interactiveShop'
import { BUTTONS, IMAGE, TEXT, TITLE } from '../../../../modals/universalModal'
import { MAIN } from '../../../../../constants/shared/states/names'
import { TEENS_TELEGRAM } from '../../../../../constants/events'
import { promoTeensModalTelegram } from '../../../../../constants/copyright-modals'
import { useOnboarding } from '../../../../../redux/reducer/content'

export default function usePromoTeensModalTelegram() {
  const { closeModal } = useModal()
  const { setState } = useStateControls()
  const setBackground = useSetBackground()
  const { title, description, buttons, img } = promoTeensModalTelegram

  const now = new Date()
  const start = new Date('2026-02-20T00:00:00')
  const end = new Date('2026-02-26T23:59:59')
  const isPromoPeriod = now >= start && now <= end
  const { eventModalsVisible } = useOnboarding()

  return useMemo(
    () =>
      eventModalsVisible &&
      isPromoPeriod && {
        id: 'promoTeensModalTelegram',
        type: 'universalModal',
        event: TEENS_TELEGRAM,
        props: {
          modalProps: {
            wrapper: { isFullPage: false },
            modifier: ['noFullNoScroll', 'width-image-full'],
          },
          components: [
            {
              list: [
                {
                  type: IMAGE,
                  props: {
                    modifier: 'width-full',
                    img,
                  },
                },
                {
                  type: TITLE,
                  props: {
                    modifier: 'padding-no',
                    value: title,
                  },
                },
                {
                  type: TEXT,
                  props: {
                    value: description,
                  },
                },
                {
                  type: BUTTONS,
                  props: {
                    buttons: buttons?.map((button) => {
                      const { tag = 'button', isLink, href, target, text, ...rest } = button

                      const baseProps = {
                        tag,
                        text,
                        ...rest,
                      }

                      if (isLink && href) {
                        return {
                          ...baseProps,
                          href,
                          target,
                          rel: target === '_blank' ? 'noreferrer' : undefined,
                          disposable: true,
                          onClick: () => closeModal('all'),
                        }
                      }

                      return {
                        ...baseProps,
                        disposable: true,
                        async onClick() {
                          await setBackground()
                          setState(MAIN)
                          closeModal('all')
                        },
                      }
                    }),
                  },
                },
              ],
            },
          ],
        },
      },
    [img, title, description, buttons, closeModal, setBackground, setState, eventModalsVisible],
  )
}
